import { DateTime } from 'luxon';
import CalendarFixedRangePicker from '../../CalendarFixedRangePicker';
import { Button } from '../../Common';
import { useHttpEditOngoingLeaveRequest } from '../../../hooks';
import { useState } from 'react';
import { LeaveRequestDto } from '../../../commonTypes/leaveRequest.types';
import { useTranslation } from '../../../hooks/useTranslation';

interface IEditOngoingLeaveRequestProps {
    request: LeaveRequestDto;
    close: () => void;
    editOngoingLeaveRequestCb: (request: LeaveRequestDto) => void;
}

const EditOngoingLeaveRequest = ({ request, close, editOngoingLeaveRequestCb }: IEditOngoingLeaveRequestProps) => {
    const { t } = useTranslation();
    const { exec: editLeaveRequest } = useHttpEditOngoingLeaveRequest();
    const [endDate, setEndDate] = useState(DateTime.fromISO(request.toDate));

    const handleEndDateChange = (newEndDate: DateTime) => {
        setEndDate(newEndDate);
    };

    const editOngoingRequest = () => {
        const { day, month, year } = endDate;
        const toDate = DateTime.fromObject({ day, month, year }, { zone: 'utc' });
        request.toDate = toDate.toISO();
        editLeaveRequest(request, toDate.toISODate(), editOngoingLeaveRequestCb);
        close();
    };

    const cannotSubmit = () => {
        const { day: reqDay, month: reqMonth, year: reqYear } = DateTime.fromISO(request.toDate);
        const { day, month, year } = endDate;
        return day === reqDay && month === reqMonth && year === reqYear;
    };

    return (
        <div className="ongoing-leave-request">
            <h3 className="ongoing-leave-request__header">{t('leaveRequest.editOngoingTitle')}</h3>
            <div className="ongoing-leave-request__form">
                <CalendarFixedRangePicker
                    disabledDays={[]}
                    onPeriodChange={() => {}}
                    fixedRangeStart={DateTime.fromISO(request.fromDate)}
                    fixedRangeEnd={DateTime.fromISO(request.toDate)}
                    onEndDateChange={handleEndDateChange}
                    endDate={endDate}
                />
            </div>
            <div className="ongoing-leave-request__buttons">
                <Button text={t('common.cancel')} variant="text" onClick={close} color="blue" />
                <Button text={t('common.edit')} disabled={cannotSubmit()} onClick={() => editOngoingRequest()} />
            </div>
        </div>
    );
};

export default EditOngoingLeaveRequest;
